import { defineNuxtPlugin } from "#imports";
import { NUXT_STATE_KEY } from "./constants.js";
import { getRequestLocale } from "./utils/getRequestLocale.js";
export default defineNuxtPlugin({
  name: "i18nLocale",
  setup: (nuxt) => {
    if (nuxt.ssrContext) {
      const locale = getRequestLocale(nuxt.ssrContext.event);
      nuxt.payload.state[NUXT_STATE_KEY] = {
        locale
      };
    }
  }
});
